import SimpleQuestion from "./SimpleQuestion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { getLanguageCode } from "../store/components";
import * as theme from "../theme";
import { useEffect, useState } from "react";
import _ from "lodash";
import { StringInputForMiniForm } from "./SimpleString";
import { YesNoRadioForMiniForm } from "./YesNo";
import { getQuestionDetailsFromQuestionTable } from "../store/qf";
import {
  CURRENCY,
  INSURER,
  NUMBER,
  PERCENTAGE,
  SIMPLESTRING,
  YEAR,
  YESNO,
} from "../store/businesslogic/hardwiredlogic";
import { PercentageSliderForMiniForm } from "./Percentage";
import { NumberInputForMiniForm } from "./Number";
import { CurrencyInputForMiniForm } from "./Currency";
import { YearInput } from "./Year";
import { useStylesLocally } from "../muithemeclasses";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";
const MulitiSelectPlatinum = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  const { answer } = node;
  const mainAnswerHandle = (event, value) => {
    if (_.isEmpty(answer)) {
      handleAnswerChange({ main: value });
    } else {
      //TODO : IF THE VALUE IS NOT EMPTY, THEN answer.internal SHOULD BE AS PER ARRYA OF THE VALUE;

      if (!_.isEmpty(value)) {
        let newInternal = {};

        value.forEach((option) => {
          const { code } = option;

          newInternal[code] = answer.internal
            ? answer.internal[code]
              ? answer.internal[code]
              : {}
            : {};
        });
        handleAnswerChange({ internal: newInternal, main: value });
      } else {
        handleAnswerChange({ internal: {}, main: value });
      }
    }
  };

  const internalAnswerChange = (code, questionid, changedValue) => {
    let newAnswer = {
      ...answer,
      internal: {
        ...answer.internal,
        [code]: answer.internal
          ? { ...answer.internal[code], [questionid]: changedValue }
          : { [questionid]: changedValue },
      },
    };
    //newAnswer.internal[code] = {};
    // newAnswer.internal[code][questionid] = changedValue;

    handleAnswerChange(newAnswer);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "5vh",
      }}
    >
      <SimpleQuestion
        leftString={text}
        node={node}
        rightComponent={
          <MulitiSelectPlatinumDropDown
            node={node}
            handleAnswerChange={mainAnswerHandle}
            qfusermode={qfusermode}
          ></MulitiSelectPlatinumDropDown>
        }
      ></SimpleQuestion>
      <MSPMiniForm
        node={node}
        handleAnswerChange={internalAnswerChange}
        qfusermode={qfusermode}
      ></MSPMiniForm>
    </div>
  );
};

const MulitiSelectPlatinumDropDown = ({
  node,
  handleAnswerChange,
  qfusermode,
}) => {
  const languagecode = useSelector(getLanguageCode);
  const classes = useStylesLocally();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  return (
    <Autocomplete
      multiple
      id={`MulitiSelectPlatinum_${node.id}`}
      options={node.logic.options}
      getOptionLabel={(option) =>
        option.text[languagepreference] ? option.text[languagepreference] : null
      }
      classes={{
        root: classes.rootForMultiSelect,
        listbox: classes.listbox,
        input: classes.input,
        tag: classes.tag,
      }}
      disableCloseOnSelect
      onChange={handleAnswerChange}
      value={node.answer?.main ? node.answer.main : []}
      disabled={qfusermode === INSURER ? true : false}
      renderInput={(params) => (
        <TextField
          {...params}
          classes={{
            root: classes.textFieldRootForMultiSelect,
          }}
          placeholder={translations[languagepreference].selectMultiple}
          fullWidth
          // onFocus={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText(
          //       this.props.questionHint
          //     );
          //   }
          // }}
          // onBlur={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
          //   }
          // }}
        />
      )}
    />
  );
};

const MSPMiniForm = ({ node, handleAnswerChange, qfusermode }) => {
  const { answer, logic } = node;

  const [currentcodeindex, setCurrentcodeIndex] = useState(0);

  const handleNextButtonClick = () => {
    let nextCodeIndex = currentcodeindex + 1;

    if (!answer.main[nextCodeIndex]) setCurrentcodeIndex(0);
    else {
      setCurrentcodeIndex(nextCodeIndex);
    }
  };

  useEffect(() => {
    setCurrentcodeIndex(0);
  }, [answer?.main]);

  return (
    <div>
      {answer?.main.length > 0 ? (
        <div style={{ padding: "2vw", paddingTop: 12, paddingBottom: 0 }}>
          <MiniForm
            currentcodeindex={currentcodeindex}
            totalindexes={answer?.main.length}
            node={node}
            mainanswer={answer.main}
            currentcode={answer.main[currentcodeindex]?.code}
            logic={logic}
            handleNextButtonClick={handleNextButtonClick}
            handleAnswerChange={handleAnswerChange}
            qfusermode={qfusermode}
          ></MiniForm>
        </div>
      ) : null}
    </div>
  );
};

const MiniForm = ({
  mainanswer,
  currentcode,
  logic,
  handleNextButtonClick,
  node,
  handleAnswerChange,
  currentcodeindex,
  totalindexes,
  qfusermode,
}) => {
  const languagecode = useSelector(getLanguageCode);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  let currentcodeobject = mainanswer.filter(
    (answer) => answer.code === currentcode
  )[0];
  if (currentcode === null || currentcode === undefined) return null;
  return (
    <div
      style={{
        width: "100%",
        minHeight: theme.SCALES.minHeightForMultiSelectPlatinum,
        backgroundColor: theme.COLORS.primary_navyblue,
        color: "white",
        borderRadius: 15,
        padding: "2vw",
        display: "flex",
        flexDirection: "column",
        borderTopRightRadius: 0,
        justifyContent: "space-between",
        boxShadow: "4px 12px 17px 0px rgba(0,0,0,0.47)",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "4.5vh",
          display: "flex",
          letterSpacing: 1,
          fontSize: "2vmin",
          justifyContent: "space-between",
        }}
      >
        <div>{currentcodeobject.text[languagepreference]}</div>
        <div style={{ fontSize: "1.4vmin", fontFamily: "GibsonLight" }}>{`${
          currentcodeindex + 1
        }/${totalindexes}`}</div>
      </div>
      <div style={{ width: "100%", flexGrow: 1 }}>
        {currentcodeobject.questions.map((questionid, index) => (
          <EachMiniQuestion
            key={index + "_" + questionid}
            questionid={questionid}
            currentcode={currentcode}
            node={node}
            handleAnswerChange={handleAnswerChange}
            languagecode={languagepreference}
            qfusermode={qfusermode}
          ></EachMiniQuestion>
        ))}
      </div>
      {mainanswer.length > 1 ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "6vh",
            alignItems: "center",
            paddingTop: "3vh",
          }}
        >
          <SmallNextButton onClick={handleNextButtonClick}></SmallNextButton>
        </div>
      ) : null}
    </div>
  );
};

const SmallNextButton = ({ onClick }) => {
  return (
    <div
      style={{
        color: "white",
        fontFamily: "GibsonRegular",
        fontSize: 12,
        backgroundColor: theme.COLORS.secondary_skyblue,
        width: "15%",
        borderRadius: "5%",
        height: "3vh",
        letterSpacing: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      Next
    </div>
  );
};

const EachMiniQuestion = ({
  currentcode,
  questionid,
  node,
  handleAnswerChange,
  languagecode,
  qfusermode,
}) => {
  const questionDetails = useSelector(
    getQuestionDetailsFromQuestionTable({ questionid })
  );
  const decideRigtComponent = ({
    questionDetails,
    currentcode,
    questionid,
    node,
    handleAnswerChange,
  }) => {
    const { type } = questionDetails;

    if (type === SIMPLESTRING)
      return (
        <StringInputForMiniForm
          code={currentcode}
          questionid={questionid}
          node={node}
          qfusermode={qfusermode}
          handleAnswerChange={handleAnswerChange}
        ></StringInputForMiniForm>
      );

    if (type === YESNO)
      return (
        <YesNoRadioForMiniForm
          code={currentcode}
          questionid={questionid}
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></YesNoRadioForMiniForm>
      );

    if (type === PERCENTAGE)
      return (
        <PercentageSliderForMiniForm
          code={currentcode}
          questionid={questionid}
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></PercentageSliderForMiniForm>
      );

    if (type === NUMBER)
      return (
        <NumberInputForMiniForm
          code={currentcode}
          questionid={questionid}
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></NumberInputForMiniForm>
      );

    if (type === CURRENCY)
      return (
        <CurrencyInputForMiniForm
          code={currentcode}
          questionid={questionid}
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></CurrencyInputForMiniForm>
      );

    if (type === YEAR)
      return (
        <YearInput
          code={currentcode}
          questionid={questionid}
          node={node}
          handleAnswerChangeForMiniForm={handleAnswerChange}
          qfusermode={qfusermode}
          miniFormMode={true}
        ></YearInput>
      );

    return <div>Contact Admin for this error</div>;
  };
  return (
    <SimpleQuestion
      leftString={questionDetails ? questionDetails.text[languagecode] : ""}
      node={node}
      textColor={"white"}
      boldness={"italic"}
      minHeight={"7vh"}
      paddingRightExplicit={0}
      qTextWidthExlpicit={"45%"}
      paddingRightForQstring={0}
      // paddingLeftForQstring={}
      rightComponent={decideRigtComponent({
        questionDetails,
        currentcode,
        questionid,
        node,
        handleAnswerChange,
      })}
    ></SimpleQuestion>
  );
};

export default MulitiSelectPlatinum;
